module.exports = __webpack_public_path__ + "img/arrow-down.8bfb71dd.svg";